import e, { useContext as b, useRef as N, useState as w, useCallback as A, useMemo as I, createContext as T } from "react";
import h from "classnames";
import { useId as H } from "react-id-generator";
import S from "react-transition-group/CSSTransition";
import { T as E } from "./index-Dd-4N6BE.es.js";
import { I as y } from "./Icon-BuIPTPJn.es.js";
import { T as O } from "./Tooltip-B-bmRvX4.es.js";
import './Accordion.css';const $ = "Accordion-module__container___cZk6G", M = "Accordion-module__showDividers___y-8SL", z = "Accordion-module__darkBg___Ew78w", R = "Accordion-module__flex_content___NUrUY", v = {
  container: $,
  showDividers: M,
  darkBg: z,
  flex_content: R
}, U = "400", V = "#2b2b2b", F = "#fff", P = "#e8e8e8", Y = "#666", G = "20px", K = "#ccc", L = "Content-module__content___Um3-Y", W = "Content-module__showDividers___RPwVB", Z = "Content-module__darkBg___5um4M", j = "Content-module__title___IoDHt", q = "Content-module__expanderIconContainer___KriFC", J = "Content-module__tooltip___4IVa0", Q = "Content-module__childrenContainer___fcO2k", X = "Content-module__container___-Hrv1", ee = "Content-module__exitActive___Va4tE", te = "Content-module__exitDone___3NI-6", oe = "Content-module__title_text___MU2Wm", t = {
  timeout: U,
  iconColor: V,
  iconColorDarkBg: F,
  iconColorDisabled: P,
  iconColorDisabledDarkBg: Y,
  iconSize: G,
  disabledTextColor: K,
  content: L,
  showDividers: W,
  darkBg: Z,
  title: j,
  expanderIconContainer: q,
  tooltip: J,
  childrenContainer: Q,
  container: X,
  exitActive: ee,
  exitDone: te,
  title_text: oe
}, ne = ({
  children: i,
  tooltip: c
}) => c ? /* @__PURE__ */ e.createElement(O.Hover, { placement: "left", trigger: /* @__PURE__ */ e.createElement(e.Fragment, null, i) }, /* @__PURE__ */ e.createElement("div", { className: t.tooltip }, /* @__PURE__ */ e.createElement(E.Body3, { tagName: "span", responsive: !0 }, c))) : /* @__PURE__ */ e.createElement(e.Fragment, null, i), re = ({
  children: i = void 0,
  title: c,
  alwaysOpen: d = !1,
  disabled: l = !1,
  tooltip: _,
  toggleCallback: f = () => {
  },
  activeTitleBg: m = void 0,
  activeTitleTextColor: x = void 0
}) => {
  const o = b(B), p = N(null), n = () => l ? !1 : d ? !0 : o.open, D = (s) => s === "entered" ? "none" : p.current ? s !== "exited" ? p.current.clientHeight : 0 : n() ? "none" : 0, a = (s) => s !== "entered" ? "hidden" : o.flexContent && !d ? "auto" : "visible", r = `iconColor${l ? "Disabled" : ""}${o.darkBg ? "DarkBg" : ""}`, C = n() && m ? { backgroundColor: m } : void 0, k = n() ? x : void 0;
  let u;
  o.iconType === "chevron" ? u = "arrow_right" : u = n() ? "minus" : "open";
  const [g] = H(1, "accordiont-content-");
  return /* @__PURE__ */ e.createElement(
    "li",
    {
      className: h(t.content, {
        [t.darkBg]: o.darkBg,
        [t.showDividers]: !o.hideDividers
      })
    },
    /* @__PURE__ */ e.createElement(
      "button",
      {
        "aria-expanded": n(),
        "aria-controls": g,
        type: "button",
        onClick: () => o.toggleOpened(f),
        disabled: l || d,
        className: t.title,
        style: C
      },
      /* @__PURE__ */ e.createElement("div", { className: t.title_text }, /* @__PURE__ */ e.createElement(
        E.Heading5,
        {
          darkBg: o.darkBg,
          color: l ? t.disabledTextColor : k,
          responsive: !0,
          tagName: "span"
        },
        c
      )),
      !d && /* @__PURE__ */ e.createElement("div", { className: t.expanderIconContainer }, /* @__PURE__ */ e.createElement(ne, { tooltip: _ }, /* @__PURE__ */ e.createElement(
        y,
        {
          name: u,
          size: t.iconSize,
          color: t[r]
        }
      )))
    ),
    /* @__PURE__ */ e.createElement(
      S,
      {
        in: n(),
        timeout: parseInt(t.timeout, 10),
        classNames: {
          exitActive: t.exitActive,
          exitDone: t.exitDone
        }
      },
      (s) => /* @__PURE__ */ e.createElement(
        "div",
        {
          "aria-hidden": !n(),
          id: g,
          className: t.container,
          style: {
            maxHeight: D(s),
            overflow: a(s),
            display: s === "exited" && !n() ? "none" : "block"
          }
        },
        /* @__PURE__ */ e.createElement("div", { ref: p, className: t.childrenContainer }, i)
      )
    )
  );
}, B = T({
  darkBg: !1,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  toggleOpened: (i) => {
  },
  open: !1,
  flexContent: !1,
  theme: "default",
  hideDividers: !1,
  iconType: "plusMinus"
}), ie = ({
  autoclose: i = !1,
  darkBg: c = !1,
  initialOpened: d = void 0,
  flexContent: l = !1,
  children: _ = [],
  theme: f = "default",
  hideDividers: m = !1,
  iconType: x = "plusMinus"
}) => {
  const [o, p] = w(
    e.Children.map(_, (a, r) => i ? d === r : !!a.props.defaultOpened) || []
  ), n = A(
    (a, r) => {
      p((C) => C.map((u, g) => g === a ? !u : i ? !1 : u)), r();
    },
    [i]
  ), D = I(
    () => e.Children.map(_, (a, r) => ({
      darkBg: c,
      toggleOpened: (C) => n(r, C),
      open: o[r],
      flexContent: l,
      theme: f,
      hideDividers: m,
      iconType: x
    })),
    [
      _,
      c,
      n,
      o,
      l,
      f,
      m,
      x
    ]
  );
  return /* @__PURE__ */ e.createElement(
    "ul",
    {
      className: h(
        l && v.flex_content,
        v.container,
        {
          [v.darkBg]: c,
          [v.showDividers]: !m
        }
      )
    },
    e.Children.map(_, (a, r) => /* @__PURE__ */ e.createElement(B.Provider, { value: D[r] }, a))
  );
};
ie.Content = re;
export {
  ie as A
};
